/* eslint-disable @angular-eslint/prefer-inject, @angular-eslint/prefer-standalone */
import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';

export interface MohWarningAckDialogData {
  message: string;
  itemCode?: string;
}

@Component({
    selector: 'app-moh-warning-ack-dialog',
    templateUrl: './moh-warning-ack-dialog.component.html',
    styleUrls: ['./moh-warning-ack-dialog.component.scss'],
    standalone: false
})
export class MohWarningAckDialogComponent {
  comment = new FormControl('', [Validators.required]);

  constructor(
    public dialogRef: MatDialogRef<MohWarningAckDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MohWarningAckDialogData,
  ) {}

  onDismiss(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (this.comment.invalid) {
      this.comment.markAsTouched();
      return;
    }
    this.dialogRef.close((this.comment.value || '').trim());
  }
}
